import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FormattedText } from '@/components/uiKit/FormattedText';
import { locations } from '@/locations';
import { FormLayout } from '@/pages/auth/components/FormLayout';
import { analytics } from '@/analytics';
import { Icon } from '@/components/shared/display/Icon';
import { colors } from '@/constants/colors';
import { EmailLockedIcon } from '@/assets/Icons';

export const ResetLinkSentPage = () => {
  const navigate = useNavigate();
  const goBackToLogin = () => navigate(locations.public.login);

  useEffect(() => {
    analytics.page({
      name: 'Reset password link sent',
      title: 'DataMind Dashboard 2.0 - Reset password link sent',
    });
  }, []);

  return (
    <FormLayout
      title="auth.resetPassword.sent.heading"
      subtitle="auth.resetPassword.sent.description"
      icon={<Icon icon={EmailLockedIcon} className={`w-16 h-16 text-[${colors.health.healthy}] mb-6`} />}
    >
      <div className="flex items-center justify-center xl:justify-end">
        <Button variant="default" size="lg" className="rounded-full" onClick={goBackToLogin}>
          <FormattedText label="auth.resetPassword.sent.submit" />
        </Button>
      </div>
    </FormLayout>
  );
};
